const staticContent = {
  about:
    "We are the Coded Hearts, an LA based rock band! We have been performing since 2014.",
};

export default staticContent;
